import jsPDF from "jspdf";
import "jspdf-autotable";
import GemarBg from "../../../images/Gemar-USA-Logo-RGB-POS.png";

const MRPurchaseOrderPDF = (
  tableRows,
  columns,
  isLandscape,
  title,
  merchandiseReceptionModel,
  columnStyles
) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  const left = 14;
  const top = 5;
  const imgWidth = 50;
  const imgHeight = 15;
  const pageWidth = doc.internal.pageSize.getWidth();

  // 👉 50/50 width for two columns per row
  const halfWidth = (pageWidth - left * 2 - imgWidth - 10) / 2;
  const subHeaderleft = 14;

  /** ---------------------- HEADER IMAGE & TITLE ---------------------- */
  const header = () => {
    doc.addImage(GemarBg, "PNG", left, top, imgWidth, imgHeight);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128);
    doc.text(left + imgWidth + 10, 10, title);
    doc.text(
      left + imgWidth + 10,
      14,
      "Gemar USA – Distributor Phone: +1 (786) 7622949."
    );
  };

  /** ---------------------- TEXT DRAW FUNCTION ---------------------- */
  let productTop = 26;

  const drawText = (label, value, index, marginRight = 5) => {
    const startX = subHeaderleft + index * halfWidth;
    const labelText = `${label} :`;
    doc.setFontSize(12);

    // Print label
    doc.text(labelText, startX, productTop);

    // Calculate wrapped width
    const labelWidth = doc.getTextWidth(labelText) + 2;
    const maxValueWidth = halfWidth - labelWidth - marginRight;

    const wrappedValue = doc.splitTextToSize(value || "", maxValueWidth);

    // Print value right next to label
    doc.text(wrappedValue, startX + labelWidth, productTop);
  };

  /** ---------------------- FIRST ROW (50/50) ---------------------- */
  drawText(
    "Purchase Order #",
    merchandiseReceptionModel?.PurchaseOrderNumber || "",
    0
  );
  drawText("Invoice Number", merchandiseReceptionModel?.InvoiceNumber || "", 1);

  productTop += 7; // Next row

  /** ---------------------- SECOND ROW (50/50) ---------------------- */
  drawText("Vendor Name", merchandiseReceptionModel?.Vendor || "", 0);
  drawText("Warehouse #", merchandiseReceptionModel?.WareHouseNumber || "", 1);

  /** ---------------------- TABLE SECTION ---------------------- */
  doc.autoTable({
    theme: "grid",
    columns: columns,
    body: tableRows,
    columnStyles: columnStyles,
    didDrawPage: () => header(),
    margin: {
      top: 32, // increased slightly to fit new lines
    },
    startY: 38,
    headStyles: {
      fillColor: "#00a3da",
      fontSize: 12,
      halign: "center",
    },
    styles: {
      valign: "middle",
    },
  });

  /** ---------------------- SAVE PDF ---------------------- */
  doc.save(`${title}.pdf`);
};

export default MRPurchaseOrderPDF;
